import type { AnyRoute } from '@tanstack/react-router';
import { createRoute, lazyRouteComponent } from '@tanstack/react-router';
import { z } from 'zod';
import { fetchSearchItems } from '#domains/search';

const SearchPage = lazyRouteComponent(() => import('./pages/SearchPage'));

const searchSchema = z.object({
  q: z.string().optional()
});

export const createSearchRoutes = <TParent extends AnyRoute>(
  parent: TParent
) => {
  const searchRoute = createRoute({
    path: '/search',
    getParentRoute: () => parent,
    component: SearchPage,
    validateSearch: searchSchema,
    loader: fetchSearchItems
  });

  return [searchRoute];
};
